import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline, StyledEngineProvider } from '@mui/material'
import { I18nextProvider } from 'react-i18next'

import i18n from './i18n'
import Themes from './themes'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { LayoutProvider } from './context/LayoutContext'
import { UserProvider } from './context/user/UserContext'
import { ApiDataProvider } from './context/DataApiContext'
import Loading from './components/Loading'
import { NotificationsProvider } from './context/NotificationsContext'
import { ConfirmationDialogProvider } from './context/ConfirmationDialogContext'
import { DocumentImportNotificationProvider } from './context/DocumentImportNotificationContext'
import { ExportProvider } from './context/ExportContext'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <I18nextProvider i18n={i18n}>
    <LayoutProvider>
      <Suspense fallback={<Loading />}>
        <NotificationsProvider>
          <UserProvider>
            <ApiDataProvider>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={Themes.default}>
                  <CssBaseline />
                  <ConfirmationDialogProvider>
                    <ExportProvider>
                      <DocumentImportNotificationProvider>
                        <App />
                      </DocumentImportNotificationProvider>
                    </ExportProvider>
                  </ConfirmationDialogProvider>
                </ThemeProvider>
              </StyledEngineProvider>
            </ApiDataProvider>
          </UserProvider>
        </NotificationsProvider>
      </Suspense>
    </LayoutProvider>
  </I18nextProvider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
